import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../../component/BreadCrumbBanner";
import facilitiesAPI from "../../api/facilitiesApi";

const MusicRoom = () => {
  const [musicRoom, setMusicRoom] = useState(null);

  useEffect(() => {
    fetchMusicRoom();
  }, []);

  const fetchMusicRoom = async () => {
    const res = await facilitiesAPI.music_room();

    if (res.code === 200) {
      const result = res.data;
      setMusicRoom(result);
    }
  };
  const musicData = musicRoom?.["music-room"]?.[0];
  return (
    <>
      {/* BreadCrump Section */}
      <BreadCrumbBanner
        title="Music Room"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {musicRoom && (
        <>
          {/* Music & Creativity */}
          <section className="music-room-section py-5">
            <div className="container">
              <div className="row align-items-center g-5">
                {/* IMAGE */}
                <div className="col-lg-6 animate__animated animate__fadeInRight order-1">
                  <div className="music-room-image">
                    <img
                      src={musicData?.image}
                      alt="Music Room"
                      loading="lazy"
                    />
                  </div>
                </div>
                {/* CONTENT */}
                <div className="col-lg-6 animate__animated animate__fadeInLeft order-2">
                  <span className="mrv-subtitle">{musicData?.subtitle}</span>
                  <h2 className="mrv-title">
                   {musicData?.title}
                  </h2>
                  <p className="music-room-desc">
                    <div dangerouslySetInnerHTML={{
                      __html: musicData?.description || "",
                    }}/>
                  </p>
                  <div className="music-room-features">
                    {musicData?.listings?.map((item, index) => (
                        <div key={index} className="music-card">
                          <div className="stack-icon">
                            <img src={item?.icon} className="library-icon" loading="lazy" />
                          </div>

                          <div className="stack-text">
                            <h6>{item.listingtitle}</h6>

                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.listingdescription || "",
                              }}
                            />
                          </div>
                        </div>
                      ))}
                  
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="music-creativity-section py-5 bg-light">
            <div className="container">
              <div className="row align-items-center g-5">
                <div className="col-lg-6 order-1">
                  <h2 className="mrv-title">{musicData?.encouragingtitle}</h2>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: musicData?.encouragingdescription || "",
                    }}
                  />
                </div>

                <div className="col-lg-6 order-2">
                  <img
                    src={musicData?.encouragingimage}
                    alt="Music Activities"
                    className="img-fluid rounded"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default MusicRoom;
